var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M29 23H15V21H29V23Z","fill":"#9A9A9A","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"43","height":"43","rx":"21.5","stroke":"#9A9A9A","key":1})]);
}

CloseInline.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
